export default {
  data() {
    return {
      textWeekend: '',
      textWeekday: '',
      textPromo: '',
    }
  },
  computed: {
    checkWeekend() {
      return this.textPromo;
    }
  },
  mounted() {
    if (window.isFirebaseLoaded) this.setPromoConfig();
    
    window.addEventListener('firebaseCalled', () => {
      this.setPromoConfig();
    });
  },
  methods: {
    setPromoConfig() {
      const PromoConfig = JSON.parse(window.getValue(window.remoteConfig, "promo_btn")._value);
      this.textWeekend = PromoConfig.text_promo_weekend;
      this.textWeekday = PromoConfig.text_promo_weekday;
      //init
      this.textPromo = this.textWeekday;

      let startWeekend = '';
      let endWeekend = '';
      const currentTime = new Date();

      if (new Date().getUTCDay() == 0) {
        startWeekend = new Date(new Date().setUTCDate(new Date().getUTCDate() - (2 - new Date().getUTCDay())));
      }
      else {
        startWeekend = new Date(new Date().setUTCDate(new Date().getUTCDate() + (5 - new Date().getUTCDay())));
      }
      startWeekend.setUTCHours(10, 0, 0, 0); //UTC Time = GMT+0

      if (new Date().getUTCDay() == 5 || new Date().getUTCDay() == 6 || new Date().getUTCDay() == 0) {
        endWeekend = new Date(new Date(startWeekend).setUTCDate(startWeekend.getUTCDate() + 2)); //UTC Time = GMT+0
        endWeekend.setUTCHours(17, 0, 0, 0); //UTC Time = GMT+0

        setTimeout(() => {
          this.textPromo = this.textWeekend;
        }, startWeekend.getTime() - currentTime.getTime())

        setTimeout(() => {
          this.textPromo = this.textWeekday;
        }, endWeekend.getTime() - currentTime.getTime())
      }
    }
  }
}
